import React, { useState } from "react";
import FacultyCard from "./FacultyCard";
import SessionOneFacultyList from "../data/SessionOneFacultyList";
import SessionTwoFacultyList from "../data/SessionTwoFacultyList";


const FacultyTabs = () => {
  const [activeTab, setActiveTab] = useState("season1");
  const faculties = activeTab === "season1" ? SessionOneFacultyList : SessionTwoFacultyList;

  return (
    <div className="max-w-7xl mx-auto px-4 py-10">
      {/* Tabs */}
      <div className="flex justify-start space-x-4 mb-6">
        <button
          onClick={() => setActiveTab("season1")}
          className={`px-6 py-2 text-lg font-semibold border-b-2 transition ${
            activeTab === "season1"
              ? "border-[rgb(234,126,93)] text-[rgb(234,126,93)]"
              : "border-transparent text-gray-600 hover:text-[rgb(234,126,93)]"
          }`}
        >
          Season 1
        </button>
        <button
          onClick={() => setActiveTab("season2")}
          className={`px-6 py-2 text-lg font-semibold border-b-2 transition ${
            activeTab === "season2"
              ? "border-[rgb(234,126,93)] text-[rgb(234,126,93)]"
              : "border-transparent text-gray-600 hover:text-[rgb(234,126,93)]"
          }`}
        >
          Season 2
        </button>
      </div>

      {/* Content */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pb-20">
        {faculties.map((faculty, index) => (
          <FacultyCard key={index} {...faculty} />
        ))}
      </div>
    </div>
  );
};

export default FacultyTabs;
